'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _appStepRoutes = require('../../../core/constants/appStepRoutes');

var _appStepRoutes2 = _interopRequireDefault(_appStepRoutes);

var _UILoadingSpinner = require('UIComponents/loading/UILoadingSpinner');

var _UILoadingSpinner2 = _interopRequireDefault(_UILoadingSpinner);

var _Lazy = require('../../../core/routeHandlers/Lazy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var gettingStartedStep = function gettingStartedStep(useFramedRedirect) {
  return {
    route: _appStepRoutes2.default.GETTING_STARTED,
    handler: function handler(props) {
      return _react2.default.createElement(
        _react2.default.Suspense,
        { fallback: _react2.default.createElement(_UILoadingSpinner2.default, { grow: true }) },
        _react2.default.createElement(_Lazy.GettingStarted, props)
      );
    },
    useFramedRedirect: useFramedRedirect
  };
};

exports.default = gettingStartedStep;
module.exports = exports['default'];